"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconSearch = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M18.8937023,19.7812124 L19.7780996,18.8968456 C20.0718306,18.6030841 20.0718306,18.1280791 19.7812124,17.8343481 L16.6655887,14.7187244 L15.7924805,13.8283234 L15.6249723,14.499975 C16.487458,13.3968587 16.999969,12.0093498 16.999969,10.4999845 C16.999969,6.90935586 14.0906131,4 10.4999845,4 C6.90935586,4 4,6.90935586 4,10.4999845 C4,14.0906131 6.90935586,16.999969 10.4999845,16.999969 C12.0093498,16.999969 13.3968587,16.487458 14.499975,15.6249723 L13.8426208,15.8038635 L14.7187244,16.6655887 L17.8343481,19.7812124 C18.1280791,20.0749739 18.6030841,20.0749739 18.8937023,19.7812124 Z M10.499994,14.499975 C8.29060867,14.499975 6.49999404,12.7124731 6.49999404,10.499994 C6.49999404,8.29060867 8.28749588,6.49999404 10.499994,6.49999404 C12.7093603,6.49999404 14.499975,8.28749588 14.499975,10.499994 C14.499975,12.7093603 12.7124731,14.499975 10.499994,14.499975 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconSearch')(IconSearch);